import React from 'react';
import { cn } from '@/lib/utils';

export interface NavigationLogoProps {
  logo?: React.ReactNode;
  className?: string;
}

const DefaultLogo = () => (
  <div className="size-8 shrink-0 rounded-full bg-white text-gray-500 grid place-items-center text-[10px] font-medium ring-1 ring-black/5 shadow-sm">
    Logo
  </div>
);

export const NavigationLogo: React.FC<NavigationLogoProps> = ({ logo, className }) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {logo ?? <DefaultLogo />}
    </div>
  );
};

NavigationLogo.displayName = 'NavigationLogo';
